
import { useState } from "react";
import "react-multi-date-picker/styles/backgrounds/bg-dark.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { api } from "../../../../utils/api";
import { LoginHelper } from "../../../../utils/LoginHelper";
import Button from "../../../common/button/Button";
import DetailAccentCard from "../../../common/detail/DetailAccentCard";

export default function ActionSection({ workshop }) {
	const navigate = useNavigate();
	const params = useParams();
	const workshopId = params.workshopId ?? workshop?.id;
	const [isOpen, setIsOpen] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');

	const handleRemove = () => {
		if (isLoading) return;
		setIsLoading(true);
		api.workshopRemove({
			token: LoginHelper.getToken(),
			workshop_id: workshopId,
		}).then(() => {
			setIsLoading(false);
			navigate('/workshop_list/');
		}).catch((err) => {
			setIsLoading(false);
			if (err && err.data) {
				setErrorMessage(err.data.message);
			}
		});
	}

	return (
		<DetailAccentCard bodyClassName="p-4" ariaLabel="مدیریت کارگاه">
			<p className="mb-3 font-Vazir-600 text-[13px] text-midGray">مدیریت</p>
			<div className="flex flex-col gap-2">
				<Link
					to={`/episode_add/${workshop.id}/`}
					className="rounded-[10px] border border-darkBlue/15 bg-white py-2.5 text-center font-Vazir-600 text-[14px] text-darkBlue no-underline transition hover:border-darkBlue/30"
				>
					افزودن جلسه
				</Link>
				<Link
					to={`/workshop_edit/${workshop.id}/`}
					className="rounded-[10px] bg-lightCta py-2.5 text-center font-Vazir-600 text-[14px] text-darkBlue no-underline transition hover:bg-[#E0EEF8]"
				>
					ویرایش
				</Link>
				<button
					type="button"
					className="rounded-[10px] bg-[#CC0000] py-2.5 font-Vazir-600 text-[14px] text-white transition hover:opacity-90"
					onClick={() => setIsOpen(!isOpen)}
				>
					حذف
				</button>
			</div>
			{isOpen && (
				<div className="mt-4 rounded-[10px] border border-darkBlue/10 bg-lightCta/50 p-3">
					<p className="font-Vazir-600 text-[14px] text-midGray">
						آیا از حذف کارگاه مطمئن هستید؟
					</p>
					<div className="mt-3 flex flex-row items-center gap-2">
						<button
							type="button"
							className="rounded-[10px] bg-white px-3 py-1.5 font-Vazir-600 text-[13px] text-darkBlue"
							onClick={() => setIsOpen(false)}
						>
							خیر
						</button>
						<div className="min-h-[32px] min-w-[56px]">
							<Button
								onClick={handleRemove}
								label="بله"
								isLoading={isLoading}
								color="#CC0000"
								textColor="#ffffff"
							/>
						</div>
					</div>
				</div>
			)}
			{errorMessage && (
				<p className="mt-2 text-center font-Vazir-400 text-[13px] text-[#cc0000]">
					{errorMessage}
				</p>
			)}
		</DetailAccentCard>
	);
}
